import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Företag som du kan företräda", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "py-2" }, "Organisationsnummer och namn", -1)
const _hoisted_3 = ["onClick"]

import { useAuthStore } from '@/stores/authStore'
import { useCaseStore } from '@/stores/caseStore'
import { useEstatesStore } from '@/stores/estateStore'
import { useServicesStore } from '@/stores/serviceStore'
import selectionCard from '@/components/ui/selection-card.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'companies-withAccess',
  setup(__props) {

const AuthStore = useAuthStore()
const CaseStore = useCaseStore()
const EstateStore = useEstatesStore()
const ServiceStore = useServicesStore()

const signerCompanies = AuthStore.getSignerCompanies
const delegates = AuthStore.getDelegates

const arraySources = [
  { type: 'company', source: signerCompanies },
  { type: 'delegateCompany', source: delegates }
]
const listedCompanies = arraySources.flatMap(({ type, source }) =>
  source.map((company) => ({
    organisationNumber: company.organisationNumber,
    name: company.name,
    type
  }))
)

function setRepresentative (organisationNumber: string, type: string) {
  AuthStore.setRepresentative(organisationNumber, type)
  CaseStore.setRepresentative(organisationNumber, type)
  EstateStore.setRepresentative(organisationNumber)
  ServiceStore.setRepresentative(organisationNumber)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listedCompanies), (company) => {
      return (_openBlock(), _createElementBlock("div", {
        key: company.organisationNumber,
        onClick: ($event: any) => (
        setRepresentative(company.organisationNumber, company.type)
      )
      }, [
        _createVNode(selectionCard, {
          object: company,
          "first-row": ['organisationNumber', 'name']
        }, null, 8, ["object"])
      ], 8, _hoisted_3))
    }), 128))
  ]))
}
}

})